import StoreORM from 'js/src/data/store-orm';
import type { LuminaryThumbnail } from 'js/src/data/thumbnail-previews/thumbnail-previews-types';
import type { RootState } from 'js/src/libs/RootState';

export function selectLuminaryThumbnail(
    state: RootState,
    id: string | number,
): HTMLCanvasElement | undefined {
    const orm = new StoreORM<LuminaryThumbnail, string | number>(
        state.thumbnailPreviews.luminaryThumbnails,
    );
    return orm.getByIdOrUndefined(id)?.get('previewCanvas');
}
